export default "__VITE_ASSET__DvyZxrPh__"